export function EmailIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_76_94)">
        <path
          d="M14.25 -0.0606689H1.74996C0.810319 -0.0606689 0.0454102 0.619875 0.0454102 1.45588V9.54411C0.0454102 10.3801 0.810319 11.0607 1.74996 11.0607H14.25C15.1896 11.0607 15.9545 10.3801 15.9545 9.54411V1.45588C15.9545 0.619875 15.1896 -0.0606689 14.25 -0.0606689ZM13.8714 0.950361L8.34159 4.64054C8.14059 4.7745 7.86006 4.7745 7.65906 4.64054L2.12852 0.950361H13.8714ZM14.25 10.0496H1.74996C1.43603 10.0496 1.18177 9.82278 1.18177 9.54411V1.58221L6.97723 5.44936C7.27765 5.6503 7.63916 5.75078 7.99996 5.75078C8.36075 5.75078 8.72226 5.65031 9.02268 5.44936L14.8181 1.58221V9.54411C14.8181 9.82278 14.5639 10.0496 14.25 10.0496Z"
          fill="#3D3D3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_76_94">
          <rect width="16" height="11" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
